<div *ngIf='!editMode' (click)='enableEdit()' class='cell'>
    <span>{{data}}</span>
    <span *ngIf="!data" class="default-desc">Enter description</span>
</div>
<input *ngIf='editMode' (focusout)="onFocusOut()" (keydown.enter)='$event.target.blur()' [(ngModel)]='data' (paste)="onKeyUp()" (keyup)="onKeyUp()"
       [ngClass]="[ 'cellInput', lengthValidationClass, additionalClass]" appAutofocus type='text' (focusout)="disableEdit()" [placeholder]='placeholder'>
<mat-hint *ngIf="editMode && charCounter">{{data.length}} / {{maxLength}}</mat-hint>
